<template>
  <BaseModal
    :is-open="isOpen"
    close-on-esc-key-click
    @close="$emit('close')"
  >
    <div
      v-if="addon"
      class="flex flex-col items-center gap-6 text-center"
    >
      <div class="size-60 rounded overflow-hidden bg-grey-100 flex items-center justify-center">
        <img
          v-if="addon.imageUrl && !hasBrokenImage"
          :src="addon.imageUrl"
          :alt="addon.name"
          class="size-full object-cover rounded shadow-elevation-small"
          @error="hasBrokenImage = true"
        >
        <TagIcon
          v-else
          :icon="PackagePlusIcon"
          color="mono-light"
          class="h-16 w-16"
        />
      </div>

      <h3 class="m-0 text-2xl font-semibold text-grey-800 wrap-anywhere">
        {{ addon.name }}
      </h3>

      <p
        v-if="addon.description"
        class="m-0 text-sm text-grey-800 whitespace-pre-line wrap-anywhere"
      >
        {{ addon.description }}
      </p>
    </div>

    <template #actions>
      <div class="w-full flex justify-center">
        <BaseButton color="white" @click="$emit('close')">
          Got it
        </BaseButton>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import PackagePlusIcon from '@tagvenue/icons/24/line/development/package-plus.svg?component';
import { computed, ref, watch } from 'vue';

import TagIcon from '@/components/TagIcon.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';
import BaseModal from '@/components/Ui/Modals/BaseModal.vue';

const props = defineProps({
  addon: {
    type: Object,
    default: null,
  },
});

defineEmits(['close']);

const isOpen = computed(() => props.addon !== null);

const hasBrokenImage = ref(false);

watch(() => props.addon?.imageUrl, () => {
  hasBrokenImage.value = false;
});
</script>
